import lazyLoad from '@/utils/lazyLoad';

/** 移动端「请跳转 PC」占位页；埋点预览用组件引用比对排除 */
export const MobileDefaultPage = lazyLoad(
  () => import('@/pages/mobilePage/defaultPage')
);
